export const DEPOSIT_TOKEN = {
  LABR: "LABR",
  TON: "TON"
} as const
export type IDepositToken = (typeof DEPOSIT_TOKEN)[keyof typeof DEPOSIT_TOKEN]

export interface ICreateDepositInvoiceArgs {
  address: string
  token: IDepositToken
  amount: number
}

export interface IDepositMessage {
  address: string
  amount: string
  payload?: string
  stateInit?: string
}

export interface ICreateDepositInvoiceResponse {
  validUntil: number
  messages: IDepositMessage[]
}
